(function (window, document) {
    'use strict';

    var selector = '[data-self-funded-estimate]';
    var maximumFiles = 10;
    var maximumFileSize = 10 * 1024 * 1024;
    var maximumCombinedFileSize = 50 * 1024 * 1024;
    var allowedExtension = /\.(pdf|doc|docx|jpe?g|png|gif|webp|bmp|tiff?)$/i;

    function element(tag, className, text) {
        var result = document.createElement(tag);
        if (className) result.className = className;
        if (text !== undefined) result.textContent = text;
        return result;
    }

    function responseJson(response) {
        return response.json().catch(function () {
            return { success: false, message: 'The request could not be completed. Please try again.' };
        }).then(function (body) {
            if (!response.ok || body.success === false) {
                var error = new Error(body.message || 'The request could not be completed. Please try again.');
                error.errors = body.errors;
                throw error;
            }
            return body;
        });
    }

    function initialise(widget) {
        if (widget.getAttribute('data-estimate-ready') === 'true') return;
        widget.setAttribute('data-estimate-ready', 'true');
        var form = widget.querySelector('[data-estimate-form]');
        if (!form) return;
        var editMode = widget.getAttribute('data-edit-mode') === 'true';
        var submitButton = form.querySelector('[data-estimate-submit]');
        var status = form.querySelector('[data-estimate-status]');
        var formError = form.querySelector('[data-estimate-form-error]');
        var hospitalSelect = form.querySelector('[data-estimate-hospital]');
        var contact = widget.querySelector('[data-estimate-contact]');
        var hospitals = [];
        var files = [];
        var fileCounter = 0;
        var rowCounter = 0;
        var submitting = false;
        var submitted = false;
        var hospitalLoadFailed = false;
        var prosthesisRows = form.querySelector('[data-estimate-prosthesis-rows]');
        var addItemButton = form.querySelector('[data-estimate-add-item]');
        var uploadInput = form.querySelector('[data-estimate-files]');
        var uploadList = form.querySelector('[data-estimate-file-list]');
        var today = new Date();
        var todayIso = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);

        function field(name) { return form.elements.namedItem(name); }
        function selectedHospital() {
            for (var i = 0; i < hospitals.length; i += 1) {
                if (hospitals[i].value === hospitalSelect.value) return hospitals[i];
            }
            return null;
        }
        function uploadsPending() {
            return files.some(function (file) { return file.state === 'uploading'; });
        }
        function updateSubmit() {
            var hospital = selectedHospital();
            submitButton.disabled = editMode || submitting || submitted || uploadsPending() || hospitalLoadFailed || (hospital && hospital.available === false);
            submitButton.textContent = submitting ? 'Submitting…' : 'Submit estimate request';
            form.setAttribute('aria-busy', submitting ? 'true' : 'false');
        }
        function clearErrors() {
            var errors = form.querySelectorAll('[data-field-error]');
            var invalidFields = form.querySelectorAll('[aria-invalid="true"]');
            for (var i = 0; i < errors.length; i += 1) errors[i].textContent = '';
            for (var j = 0; j < invalidFields.length; j += 1) invalidFields[j].removeAttribute('aria-invalid');
            formError.textContent = '';
            formError.hidden = true;
        }
        function showErrors(errors, message) {
            clearErrors();
            var firstInvalid = null;
            var generalErrors = [];
            Object.keys(errors || {}).forEach(function (name) {
                var messages = Array.isArray(errors[name]) ? errors[name] : [String(errors[name])];
                var target = field(name);
                if ((name === 'IcuNights' || name === 'HduNights') && target && target.disabled) return;
                var errorTarget = null;
                var errorTargets = form.querySelectorAll('[data-field-error]');
                for (var i = 0; i < errorTargets.length; i += 1) {
                    if (errorTargets[i].getAttribute('data-field-error') === name) errorTarget = errorTargets[i];
                }
                if (!errorTarget && name.indexOf('ProsthesisItems') === 0) {
                    errorTarget = form.querySelector('[data-field-error="ProsthesisItems"]');
                }
                if (name === 'UploadTokens') target = uploadInput;
                if (name.indexOf('ProsthesisItems') === 0) target = prosthesisRows.querySelector('input,select') || addItemButton;
                var controls = target && target.length && !target.tagName ? Array.prototype.slice.call(target) : target ? [target] : [];
                controls.forEach(function (control) {
                    control.setAttribute('aria-invalid', 'true');
                    if (!firstInvalid && !control.disabled && control.type !== 'hidden' && control.getClientRects().length) firstInvalid = control;
                });
                if (errorTarget) {
                    errorTarget.textContent += (errorTarget.textContent ? ' ' : '') + messages.join(' ');
                    if (!firstInvalid && errorTarget.getClientRects().length) {
                        errorTarget.setAttribute('tabindex', '-1');
                        firstInvalid = errorTarget;
                    }
                } else {
                    generalErrors = generalErrors.concat(messages);
                }
            });
            if (message) generalErrors.push(message);
            if (generalErrors.length) {
                formError.textContent = generalErrors.join(' ');
                formError.hidden = false;
            }
            if (firstInvalid) firstInvalid.focus();
            else if (generalErrors.length) formError.focus();
        }
        function updateContact() {
            var hospital = selectedHospital();
            contact.textContent = '';
            if (!hospital) {
                var emptyInstructions = contact.getAttribute('data-empty-contact');
                contact.appendChild(element('p', '', emptyInstructions === null ? 'Select a hospital in step 1 to see the estimates team contact.' : emptyInstructions));
            } else {
                contact.appendChild(element('p', 'self-funded-estimate__hospital-name', hospital.text));
                if (hospital.available === false) {
                    var unavailableInstructions = contact.getAttribute('data-unavailable-contact');
                    contact.appendChild(element('p', '', unavailableInstructions === null ? 'Online estimate requests are currently unavailable for this hospital. Please contact the hospital directly.' : unavailableInstructions));
                } else {
                    if (hospital.email) {
                        var email = element('a', '', hospital.email);
                        email.href = 'mailto:' + hospital.email;
                        contact.appendChild(email);
                    }
                    if (hospital.phone) {
                        String(hospital.phone).split(/\s*\/\s*/).forEach(function (number) {
                            var phone = element('a', '', number);
                            phone.href = 'tel:' + number.replace(/[^+\d]/g, '');
                            contact.appendChild(phone);
                        });
                    }
                }
            }
            updateSubmit();
        }
        function loadHospitals() {
            hospitalSelect.disabled = true;
            var hospitalsUrl = widget.getAttribute('data-hospitals-url');
            var contactsToken = widget.getAttribute('data-hospital-contacts-token');
            var hospitalHeaders = { Accept: 'application/json' };
            if (contactsToken) hospitalHeaders['X-Estimate-Hospital-Contacts'] = contactsToken;
            window.fetch(hospitalsUrl, { credentials: 'same-origin', headers: hospitalHeaders })
                .then(responseJson).then(function (result) {
                    hospitals = Array.isArray(result.hospitals) ? result.hospitals : [];
                    hospitalSelect.textContent = '';
                    var empty = element('option', '', 'Select a hospital');
                    empty.value = '';
                    hospitalSelect.appendChild(empty);
                    var stateNames = { NSW: 'New South Wales', VIC: 'Victoria', QLD: 'Queensland' };
                    ['NSW', 'VIC', 'QLD'].forEach(function (state) {
                        var group = element('optgroup');
                        group.label = stateNames[state];
                        hospitals.filter(function (hospital) { return hospital.state === state; }).forEach(function (hospital) {
                            var option = element('option', '', hospital.text + (hospital.available === false ? ' — currently unavailable' : ''));
                            option.value = hospital.value;
                            group.appendChild(option);
                        });
                        if (group.childNodes.length) hospitalSelect.appendChild(group);
                    });
                    if (!hospitals.length) throw new Error('Hospital options are currently unavailable. Please try again later.');
                    hospitalSelect.disabled = false;
                    updateContact();
                }).catch(function (error) {
                    hospitalLoadFailed = true;
                    hospitalSelect.textContent = '';
                    var option = element('option', '', 'Hospital options unavailable');
                    option.value = '';
                    hospitalSelect.appendChild(option);
                    showErrors({ Hospital: [error.message] });
                    updateSubmit();
                });
        }
        function updateConditionalFields() {
            field('MedicareNumber').disabled = field('MedicareNotApplicable').checked;
            if (field('MedicareNotApplicable').checked) field('MedicareNumber').value = '';
            field('AdmissionDate').disabled = field('AdmissionDateTbc').checked;
            if (field('AdmissionDateTbc').checked) field('AdmissionDate').value = '';
            var overnight = form.querySelector('input[name="AdmissionType"]:checked');
            overnight = overnight && overnight.value === 'Overnight';
            field('NumberOfNights').disabled = !overnight;
            field('NumberOfNights').required = !!overnight;
            var nightsLabel = form.querySelector('label[for="' + field('NumberOfNights').id + '"]');
            var nightsRequired = nightsLabel.querySelector('.self-funded-estimate__required');
            if (!nightsRequired) {
                nightsRequired = element('span', 'self-funded-estimate__required', '\u00a0*');
                nightsRequired.setAttribute('aria-hidden', 'true');
                nightsLabel.appendChild(nightsRequired);
            }
            nightsRequired.hidden = !overnight;
            if (!overnight) field('NumberOfNights').value = '';
            var screened = form.querySelector('input[name="IcuHduScreened"]:checked');
            var noIcuHduScreening = screened && screened.value === 'No';
            ['IcuNights', 'HduNights'].forEach(function (name) {
                var nights = field(name);
                nights.disabled = !!noIcuHduScreening;
                if (noIcuHduScreening) {
                    nights.value = '';
                    nights.removeAttribute('aria-invalid');
                    var error = form.querySelector('[data-field-error="' + name + '"]');
                    if (error) error.textContent = '';
                }
            });
            var noProsthesis = field('NoProsthesis').checked;
            form.querySelector('[data-estimate-prostheses]').hidden = noProsthesis;
            var inputs = prosthesisRows.querySelectorAll('input,select,button');
            for (var i = 0; i < inputs.length; i += 1) inputs[i].disabled = noProsthesis;
        }
        function prosthesisInput(row, name, title, type, options) {
            var wrapper = element('div', 'self-funded-estimate__field' + (name === 'RebateCode' ? ' self-funded-estimate__field--rebate' : ''));
            var input = element(options ? 'select' : 'input');
            input.id = form.id + '-prosthesis-' + row.getAttribute('data-row-id') + '-' + name;
            input.setAttribute('data-prosthesis-field', name);
            if (options) {
                options.forEach(function (value) {
                    var option = element('option', '', value || 'Select');
                    option.value = value;
                    input.appendChild(option);
                });
            } else {
                input.type = type || 'text';
                input.maxLength = 500;
                if (type === 'number') { input.min = '1'; input.max = '1000'; input.step = '1'; input.value = '1'; }
            }
            var label = element('label', '', title);
            label.htmlFor = input.id;
            wrapper.appendChild(label);
            wrapper.appendChild(input);
            row.appendChild(wrapper);
        }
        function renumberRows() {
            var rows = prosthesisRows.children;
            for (var i = 0; i < rows.length; i += 1) {
                rows[i].querySelector('[data-item-label]').textContent = 'Item ' + (i + 1);
            }
            addItemButton.disabled = rows.length >= 10;
        }
        function addProsthesisRow() {
            if (prosthesisRows.children.length >= 10) return;
            var row = element('div', 'self-funded-estimate__prosthesis');
            row.setAttribute('data-row-id', String(++rowCounter));
            var heading = element('div', 'self-funded-estimate__item-heading');
            var itemLabel = element('strong', '', 'Item');
            itemLabel.setAttribute('data-item-label', '');
            var remove = element('button', 'self-funded-estimate__remove', 'Remove item');
            remove.type = 'button';
            remove.addEventListener('click', function () { prosthesisRows.removeChild(row); renumberRows(); addItemButton.focus(); });
            heading.appendChild(itemLabel);
            heading.appendChild(remove);
            row.appendChild(heading);
            prosthesisInput(row, 'Item', 'Item', 'text');
            prosthesisInput(row, 'Quantity', 'Qty', 'number');
            prosthesisInput(row, 'Supplier', 'Device / supplier', 'text');
            prosthesisInput(row, 'RegisteredProsthesis', 'Registered prosthesis', null, ['', 'Yes', 'No']);
            prosthesisInput(row, 'RebateCode', 'Rebate item code', 'text');
            prosthesisRows.appendChild(row);
            renumberRows();
        }
        function serialiseProstheses() {
            if (field('NoProsthesis').checked) return [];
            var items = [];
            var rows = prosthesisRows.children;
            for (var i = 0; i < rows.length; i += 1) {
                var item = {};
                var inputs = rows[i].querySelectorAll('[data-prosthesis-field]');
                for (var j = 0; j < inputs.length; j += 1) {
                    item[inputs[j].getAttribute('data-prosthesis-field')] = inputs[j].value.trim();
                }
                // An untouched initial row is an empty optional item, not a request for a prosthesis.
                if (item.Item || item.Supplier || item.RegisteredProsthesis || item.RebateCode || (item.Quantity && item.Quantity !== '1')) items.push(item);
            }
            return items;
        }
        function syncUploadTokens() {
            field('UploadTokens').value = JSON.stringify(files.filter(function (file) { return file.state === 'complete'; }).map(function (file) { return file.token; }));
        }
        function showFile(file) {
            var row = file.row;
            row.textContent = '';
            row.appendChild(element('span', '', file.name));
            row.appendChild(element('span', 'self-funded-estimate__file-status', file.state === 'uploading' ? 'Uploading…' : file.state === 'complete' ? 'Uploaded' : file.error));
            var remove = element('button', 'self-funded-estimate__remove', 'Remove');
            remove.type = 'button';
            remove.setAttribute('aria-label', 'Remove ' + file.name);
            remove.addEventListener('click', function () {
                if (file.controller) file.controller.abort();
                files = files.filter(function (saved) { return saved.id !== file.id; });
                if (row.parentNode) row.parentNode.removeChild(row);
                syncUploadTokens();
                updateSubmit();
                uploadInput.focus();
            });
            row.appendChild(remove);
        }
        function uploadFile(source) {
            var file = { id: ++fileCounter, name: source.name, size: source.size, state: 'uploading', row: element('li') };
            files.push(file);
            uploadList.appendChild(file.row);
            showFile(file);
            if (!allowedExtension.test(source.name) || source.size > maximumFileSize || source.size === 0) {
                file.state = 'failed';
                file.error = !allowedExtension.test(source.name) ? 'Choose a PDF, Word document or image.' : source.size === 0 ? 'This file is empty.' : 'The file exceeds 10 MB.';
                showFile(file);
                return;
            }
            if (window.AbortController) file.controller = new window.AbortController();
            var headers = {
                'X-File-Name': encodeURIComponent(source.name),
                'X-Estimate-Submission': field('SubmissionToken').value,
                RequestVerificationToken: field('__RequestVerificationToken').value,
                'Content-Type': 'application/octet-stream',
                Accept: 'application/json'
            };
            window.fetch(widget.getAttribute('data-upload-url'), {
                method: 'POST', credentials: 'same-origin', headers: headers, body: source,
                signal: file.controller ? file.controller.signal : undefined
            }).then(responseJson).then(function (result) {
                if (!result.token) throw new Error('The upload could not be completed. Please remove the file and try again.');
                file.token = result.token;
                file.state = 'complete';
                showFile(file);
                syncUploadTokens();
            }).catch(function (error) {
                if (error.name === 'AbortError') return;
                file.state = 'failed';
                file.error = error.message;
                showFile(file);
            }).then(updateSubmit);
        }
        function setupSurgeonSearch() {
            var input = field('Surgeon');
            var list = form.querySelector('[data-estimate-surgeons]');
            var timer;
            var revision = 0;
            var suggestions = [];
            input.addEventListener('input', function () {
                window.clearTimeout(timer);
                field('SurgeonId').value = '';
                var term = input.value.trim();
                suggestions.forEach(function (specialist) { if (specialist.name === term) field('SurgeonId').value = specialist.id; });
                var requestRevision = ++revision;
                if (term.length < 2) { list.textContent = ''; return; }
                timer = window.setTimeout(function () {
                    window.fetch(widget.getAttribute('data-specialists-url') + '?term=' + encodeURIComponent(term), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
                        .then(responseJson).then(function (result) {
                            if (requestRevision !== revision) return;
                            suggestions = Array.isArray(result.specialists) ? result.specialists : [];
                            list.textContent = '';
                            suggestions.forEach(function (specialist) {
                                var option = element('option');
                                option.value = specialist.name;
                                list.appendChild(option);
                                if (specialist.name === input.value.trim()) field('SurgeonId').value = specialist.id;
                            });
                        }).catch(function () {
                            // Directory suggestions are optional. The server accepts a manually entered surgeon.
                        });
                }, 250);
            });
        }
        function validate() {
            var errors = {};
            var invalid = form.querySelectorAll(':invalid');
            for (var i = 0; i < invalid.length; i += 1) {
                if (invalid[i].name && !invalid[i].disabled && !errors[invalid[i].name]) errors[invalid[i].name] = [invalid[i].validationMessage];
            }
            var hospital = selectedHospital();
            if (!hospital || hospital.available === false) errors.Hospital = ['Please select a hospital accepting online estimate requests.'];
            if (uploadsPending()) errors.UploadTokens = ['Please wait for all files to finish uploading.'];
            if (files.some(function (file) { return file.state === 'failed'; })) errors.UploadTokens = ['Remove unsuccessful uploads before submitting your request.'];
            return errors;
        }
        function showSuccess(result) {
            submitted = true;
            clearErrors();
            var success = element('div', 'self-funded-estimate__success');
            success.setAttribute('tabindex', '-1');
            success.setAttribute('role', 'status');
            success.appendChild(element('h3', '', 'Your estimate request has been sent'));
            success.appendChild(element('p', '', result.message || 'Thank you. The selected hospital’s estimates team will be in touch.'));
            if (result.reference) success.appendChild(element('p', '', 'Reference: ' + result.reference));
            form.parentNode.replaceChild(success, form);
            success.focus();
        }

        form.id = form.id || 'estimate-form-' + field('SubmissionToken').value;
        field('PatientDateOfBirth').max = todayIso;
        field('AdmissionDate').min = todayIso;
        form.addEventListener('change', updateConditionalFields);
        hospitalSelect.addEventListener('change', updateContact);
        addItemButton.addEventListener('click', addProsthesisRow);
        addProsthesisRow();
        updateConditionalFields();
        if (editMode) { form.addEventListener('submit', function (event) { event.preventDefault(); }); return; }
        form.noValidate = true;
        setupSurgeonSearch();
        loadHospitals();
        uploadInput.addEventListener('change', function () {
            var selected = Array.prototype.slice.call(uploadInput.files || []);
            if (selected.length + files.length > maximumFiles) {
                showErrors({ UploadTokens: ['You can upload up to 10 files. Remove a file before adding another.'] });
                uploadInput.value = '';
                return;
            }
            var combinedSize = files.reduce(function (total, file) { return total + file.size; }, 0) + selected.reduce(function (total, file) { return total + file.size; }, 0);
            if (combinedSize > maximumCombinedFileSize) {
                showErrors({ UploadTokens: ['The combined size of your files cannot exceed 50 MB.'] });
                uploadInput.value = '';
                return;
            }
            selected.forEach(uploadFile);
            uploadInput.value = '';
            updateSubmit();
        });
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (submitting || submitted) return;
            field('ProsthesisItems').value = JSON.stringify(serialiseProstheses());
            syncUploadTokens();
            var errors = validate();
            if (Object.keys(errors).length) { showErrors(errors); return; }
            clearErrors();
            submitting = true;
            status.textContent = 'Submitting your request…';
            updateSubmit();
            var payload = new window.URLSearchParams(new window.FormData(form));
            window.fetch(form.action, {
                method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', Accept: 'application/json' }, body: payload.toString()
            }).then(responseJson).then(showSuccess).catch(function (error) {
                showErrors(error.errors || {}, error.errors ? null : error.message);
            }).then(function () {
                submitting = false;
                status.textContent = '';
                if (!submitted) updateSubmit();
            });
        });
    }

    function initialiseAll(root) {
        if (root.matches && root.matches(selector)) initialise(root);
        var widgets = root.querySelectorAll ? root.querySelectorAll(selector) : [];
        for (var i = 0; i < widgets.length; i += 1) initialise(widgets[i]);
    }
    function start() {
        initialiseAll(document);
        if (window.MutationObserver) {
            new window.MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    for (var i = 0; i < mutation.addedNodes.length; i += 1) {
                        if (mutation.addedNodes[i].nodeType === 1) initialiseAll(mutation.addedNodes[i]);
                    }
                });
            }).observe(document.body, { childList: true, subtree: true });
        }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
}(window, document));
